(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TaxOfficeDialogController', TaxOfficeDialogController);

    TaxOfficeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TaxOffice'];

    function TaxOfficeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TaxOffice) {
        var vm = this;
        vm.taxOffice = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:taxOfficeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.taxOffice.id !== null) {
                TaxOffice.update(vm.taxOffice, onSaveSuccess, onSaveError);
            } else {
                TaxOffice.save(vm.taxOffice, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
